module.exports = __webpack_public_path__ + "img/woman.7a37ed7e.webp";